export default __webpack_public_path__ + "static/media/mobile_beehive_status.e7589c5c.png";